// LOCAL
module.exports = {
  API_URL: process.env.REACT_APP_API_URL || `http://localhost:4500/api/v1/`,
  BASE_URL: process.env.REACT_APP_BASE_URL || `http://localhost:4500/api/v1/`,
  CONTENT_URL: process.env.REACT_APP_CONTENT_URL || `http://localhost:5000/`,
  BROADCAST_URL: process.env.REACT_APP_BROADCAST_URL || `http://localhost:8075`,
  GALILEO_API:
    process.env.REACT_APP_GALILEO_API || `http://localhost:5000/g-api/`,
  COURSE_URL:
    process.env.REACT_APP_COURSE_URL || `http://localhost:5000/g-api/group/`,
  ASSESSMENT_URL:
    process.env.REACT_APP_ASSESSMENT_URL || `http://localhost:6090/api/v1/`,
  WHITEBOARD_URL:
    process.env.REACT_APP_WHITEBOARD_URL || "http://localhost:8073/",
  LIVE_CLASS_URL:
    process.env.REACT_APP_LIVE_CLASS_URL || `http://localhost:6110`,
  WEBSITE_URL: process.env.REACT_APP_WEBSITE_URL || "http://localhost:3002/",
  CBMS_URL:process.env.REACT_APP_CBMS_URL || "http://localhost:7500"
};

// VAL
// module.exports = {
//   API_URL: process.env.REACT_APP_API_URL || `http://localhost:4500/api/v1/`,
//   BASE_URL: process.env.REACT_APP_BASE_URL || `https://server-validation.kneura.com/api/v1/`,
//   CONTENT_URL: process.env.REACT_APP_CONTENT_URL || `https://graph-validation.kneura.com/`,
//   BROADCAST_URL:
//     process.env.REACT_APP_BROADCAST_URL || `https://broadcast-validation.kneura.com`,
//   GALILEO_API:
//     process.env.REACT_APP_GALILEO_API || `https://graph-validation.kneura.com/g-api/`,
//   COURSE_URL:
//     process.env.REACT_APP_COURSE_URL || `https://graph-validation.kneura.com/g-api/group/`,
//   ASSESSMENT_URL:
//     process.env.REACT_APP_ASSESSMENT_URL || `https://assessment-validation.kneura.com/api/v1/`,
//   CLOUD_URL: process.env.REACT_APP_CLOUD_URL || `https://cloud-validation.kneura.com`,
//   LIVE_CLASS_URL:
//     process.env.REACT_APP_LIVE_CLASS_URL || `https://liveclass-validation.kneura.com`,
// };
